export const CLAIMS_FOOTER_TYPES = {
  ALL: 'A',
  OPEN: 'O',
  CLOSED: 'C',
  HOLD: 'H',
} as const;

export const CLAIM_STATUS = {
  Open: 'O',
  Closed: 'C',
  Hold: 'H',
  'Pre-Claim': 'P',
} as const;

/* Loss and Damage */

export const LOSS_AND_DAMAGE_COMMENT_TYPE = {
  Claim: 'E',
  'In-House': 'I',
} as const;

export const LOSS_AND_DAMAGE_FILTER_TYPES = {
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED',
} as const;

/* Over Charge */

export const OVER_CHARGE_COMMENT_TYPE = {
  External: 'x',
  'In-House': 'i',
} as const;
